import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionAgreementService {

  private path = environment.API_BASE_URL_CORE + '/permissionagreement';

  constructor(private http: HttpClient) { }

 /**
   * 
   * @param data 
   * @returns 
   */
  getPermission(data: any) : Observable<any> {
    return this.http.post(this.path, data);
  }

}
